import React, { forwardRef, useImperativeHandle, useState } from 'react'

import st from './index.scss'

/**
 * onConfirm: 确认回调
 * onCancel: 取消回调
 * confirmText: 确定文案
 * cancelText: 取消文案
 * title: 标题
 * describe: 描述
 * modalClose: 是否能点击遮罩关闭
 */
export default forwardRef(function ModalConfirm(
    {
        children, // children 支持自定义描述
        onConfirm,
        onCancel,
        confirmText = '确定',
        cancelText = '取消',
        title,
        describe,
        modalClose = false,
        ...props
    },
    ref
) {
    const [show, setShow] = useState(false)

    useImperativeHandle(ref, () => ({
        // 外部调用此方法直接显示错误 如果传入参数 则按参数显示错误信息
        show: () => setShow(true),
        hide: () => setShow(false)
    }))

    return (
        show && ( 
            <div
                {...props}
                className={st['modal-mask']}
                onClick={(e) => {
                    modalClose && setShow(false)
                    e.preventDefault()
                }}
            >
                <div className={st['confirm-box']}>
                    {title && <div className={st['title']}>{title}</div>}
                    {children ? (
                        children
                    ) : describe ? (
                        <div className={st['describe']}>{describe}</div>
                    ) : (
                        ''
                    )}
                    <div className={st['btn-box']}>
                        <div
                            onClick={(e) => {
                                e.stopPropagation()
                                onCancel ? onCancel() : setShow(false)
                            }}
                        >
                            {cancelText}
                        </div>
                        <div
                            onClick={(e) => {
                                e.stopPropagation()
                                onConfirm && onConfirm()
                            }}
                        >
                            {confirmText}
                        </div>
                    </div>
                </div>
            </div>
        )
    )
})
